import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Description`}</h3>
    <p>{`To publish and install packages to and from the public npm registry, you
must install Node.js and the npm command line interface using either a Node
version manager or a Node installer. `}<strong parentName="p">{`We strongly recommend using a Node
version manager to install Node.js and npm.`}</strong>{` We do not recommend using a
Node installer, since the Node installation process installs npm in a
directory with local permissions and can cause permissions errors when you
run npm packages globally.`}</p>
    <h3>{`Overview`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#checking-your-version-of-npm-and-node-js"
        }}>{`Checking your version of npm and
Node.js`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#using-a-node-version-manager-to-install-node-js-and-npm"
        }}>{`Using a Node version manager to install Node.js and
npm`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#using-a-node-installer-to-install-node-js-and-npm"
        }}>{`Using a Node installer to install Node.js and
npm`}</a></li>
    </ul>
    <h3>{`Checking your version of npm and Node.js`}</h3>
    <p>{`To see if you already have Node.js and npm installed and check the
installed version, run the following commands:`}</p>
    <pre><code parentName="pre" {...{}}>{`node -v
npm -v
`}</code></pre>
    <h3>{`Using a Node version manager to install Node.js and npm`}</h3>
    <p>{`Node version managers allow you to install and switch between multiple
versions of Node.js and npm on your system so you can test your
applications on multiple versions of npm to ensure they work for users on
different versions.`}</p>
    <h4>{`OSX or Linux Node version managers`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/creationix/nvm"
        }}>{`nvm`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/tj/n"
        }}>{`n`}</a></li>
    </ul>
    <h4>{`Windows Node version managers`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/marcelklehr/nodist"
        }}>{`nodist`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/coreybutler/nvm-windows"
        }}>{`nvm-windows`}</a></li>
    </ul>
    <h3>{`Using a Node installer to install Node.js and npm`}</h3>
    <p>{`If you are unable to use a Node version manager, you can use a Node
installer to install both Node.js and npm on your system.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://nodejs.org/en/download/"
        }}>{`Node.js installer`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/nodesource/distributions"
        }}>{`NodeSource installer`}</a>{`. If
you use Linux, we recommend that you use a NodeSource installer.`}</li>
    </ul>
    <h4>{`OS X or Windows Node installers`}</h4>
    <p>{`If you're using OS X or Windows, use one of the installers from the
`}<a parentName="p" {...{
        "href": "https://nodejs.org/en/download/"
      }}>{`Node.js download page`}</a>{`. Be sure to
install the version labeled `}<strong parentName="p">{`LTS`}</strong>{`. Other versions have not yet been
tested with npm.`}</p>
    <h4>{`Linux or other operating systems Node installers`}</h4>
    <p>{`If you're using Linux or another operating system, use one of the following
installers:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/nodesource/distributions"
        }}>{`NodeSource installer`}</a>{`
(recommended)`}</li>
      <li parentName="ul">{`One of the installers on the `}<a parentName="li" {...{
          "href": "https://nodejs.org/en/download/"
        }}>{`Node.js download
page`}</a></li>
    </ul>
    <p>{`Or see `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/download/package-manager/"
      }}>{`this page`}</a>{` to
install npm for Linux in the way many Linux developers prefer.`}</p>
    <h4>{`Less-common operating systems`}</h4>
    <p>{`For more information on installing Node.js on a variety of operating
systems, see `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/download/package-manager/"
      }}>{`this page`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      